export enum LoginType {
  Account, // 账号密码登录
  Token, // token 登录, android端使用
  Username, // 用户名登录, android端使用
}
